import { Directive } from '@angular/core';

@Directive({
  selector: '[upsNavbarContent]',
  standalone: false,
})
export class NavbarContentDirective {
  constructor() {}
}
